import angular from 'angular';

angular
  .module('cloudX')
  .controller('BatchDeleteDraftInvoiceDialogCtrl', [
    '$scope',
    '$element',
    'appMessages',
    '$translate',
    'close',
    batchDeleteDraftInvoiceDialogCtrl,
  ]);

function batchDeleteDraftInvoiceDialogCtrl($scope, $element, appMessages, $translate, close) {
  $scope.message = appMessages('confirmRevertDraftInvoices');
  $scope.deleteLocked = false;

  $scope.close = function(neverInvoice) {
    return close({ neverInvoice, deleteLocked: $scope.deleteLocked }, 500);
  };
  $scope.cancel = function() {
    return close(null, 500);
  };
}
